var map = {
	"./TopLiga-Footer.svg": "ab77",
	"./instagram.svg": "fbf6",
	"./mail.svg": "fc02",
	"./phone.svg": "9497",
	"./telegram2.svg": "867f",
	"./vk.svg": "223f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf52";